// Add more supported cutlines here as needed
const SCALED_CUTLINES_PACING = ["Catch Up", "On Track", "Above", "Differentiation Needed"];

// Add more supported cutlines here as needed
const SCALED_CUTLINES_TO_PACING = {
  "Catch Up": "BELOW_GRADE_LEVEL",
  "On Track": "AT_GRADE_LEVEL",
  "Above": "AHEAD_OF_GRADE_LEVEL",
  "Differentiation Needed": "DIFFERENTIATION_NEEDED",
}

export default function getPercentileColor(inputPacing) {
  const pacing = SCALED_CUTLINES_PACING.includes(inputPacing) ? 
    SCALED_CUTLINES_TO_PACING[inputPacing] : inputPacing;
  if (!pacing) return "#e5e3e1";
  else if (pacing === "BELOW_GRADE_LEVEL") return "var(--below-grade)";
  else if (pacing === "AT_GRADE_LEVEL") return "var(--at-grade)";
  else if (pacing === "AHEAD_OF_GRADE_LEVEL") return "var(--ahead-grade)";
  else if (pacing === "DIFFERENTIATION_NEEDED") return "var(--differentiate)";
  else {
    console.log("pacing: ", pacing);
    return "pink";
  }
}
